import { postApi } from '../../../utils/api'
import { getEntityTabRequestsScopeFilter } from '../../EntityTab'

import { USER_PROFILE_TAB_REQUESTS_TOTAL_API } from './UserProfileTabRequests.constants'

export function getUserProfileTabRequestsTotalCount({
  scopeFilterKey,
  userId,
}) {
  return postApi({
    data: {
      filters: getEntityTabRequestsScopeFilter({
        scopeFilterKey,
        scopeId: userId,
      }),
    },
    endpoint: USER_PROFILE_TAB_REQUESTS_TOTAL_API,
  })
}
